import { Heading, SecondaryButton } from '../../../components';
import homeBanner1 from '../../../assets/optimised/hero-img-mobile1.webp';
import homeBanner2 from '../../../assets/optimised/hero-img-mobile2.webp';
import homeBanner3 from '../../../assets/optimised/hero-img-mobile3.webp';

import css from './SectionHero.module.css';
import Slider from 'react-slick';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
};
function SectionHero(props) {
  const { intl, useHistoryPush, viewport } = props;

  const t = id => intl.formatMessage({ id });

  const isMobileLayout = viewport?.width > 0 && viewport?.width < 768;

  const altFor = i =>
    intl.formatMessage(
      { id: 'SectionHero.slideAlt', defaultMessage: 'Hero slide {index}' },
      { index: i }
    );

  return (
    <div className={css.heroSectionSlider}>
      <div className={css.fixedWidthContainer}>
        {isMobileLayout ? (
          <Slider {...sliderSettings}>
            <div className={css.heroContentWrapper}>
              <div className={css.heroImgWrapper}>
                <img src={homeBanner1} alt={altFor(1)} />
                <div className={css.heroContent}>
                  <SecondaryButton
                    type="button"
                    aria-label={t('SectionHero.mobile.cta.shopNow')}
                    onClick={() => useHistoryPush('SearchPage')}
                  >
                    {t('SectionHero.mobile.cta.shopNow')}
                  </SecondaryButton>
                </div>
              </div>
            </div>

            <div className={css.heroContentWrapper}>
              <div className={css.heroImgWrapper}>
                <img src={homeBanner2} alt={altFor(2)} />
                <div className={css.heroContent}>
                  <SecondaryButton
                    type="button"
                    aria-label={t('SectionHero.mobile.cta.buyNow')}
                    onClick={() => useHistoryPush('SearchPage')}
                  >
                    {t('SectionHero.mobile.cta.buyNow')}
                  </SecondaryButton>
                </div>
              </div>
            </div>

            <div className={css.heroContentWrapper}>
              <div className={css.heroImgWrapper}>
                <img src={homeBanner3} alt={altFor(3)} />
                <div className={css.heroContent}>
                  <SecondaryButton
                    type="button"
                    aria-label={t('SectionHero.mobile.cta.sellNow')}
                    onClick={() => useHistoryPush('NewListingPage')}
                  >
                    {t('SectionHero.mobile.cta.sellNow')}
                  </SecondaryButton>
                </div>
              </div>
            </div>
          </Slider>
        ) : (
          <Slider {...sliderSettings}>
            <div className={css.heroContentWrapper}>
              <div
                className={css.heroContentWrapperInner}
                style={{ backgroundImage: `url(${homeBanner1})`, height: '100%' }}
                aria-label={altFor(1)}
              >
                <div className={css.heroContent}>
                  <Heading as="h1" rootClassName={css.heading}>
                    {t('SectionHero.hero1.title.before')} <span>{t('SectionHero.brand')}</span>
                  </Heading>
                  <p className={css.para}>{t('SectionHero.hero1.description')}</p>
                  <SecondaryButton
                    className={css.browseBtn}
                    type="button"
                    aria-label={t('SectionHero.hero1.cta')}
                    onClick={() => useHistoryPush('SearchPage')}
                  >
                    {t('SectionHero.hero1.cta')}
                  </SecondaryButton>
                </div>
              </div>
            </div>

            <div className={css.heroContentWrapper}>
              <div
                className={css.heroContentWrapperInner}
                style={{ backgroundImage: `url(${homeBanner2})`, height: '100%' }}
                aria-label={altFor(2)}
              >
                <div className={css.heroContent}>
                  <Heading as="h1" rootClassName={css.heading}>
                    {t('SectionHero.hero2.title.before')}{' '}
                    <span>{t('SectionHero.hero2.title.emphasis')}</span>
                  </Heading>
                  <p className={css.para}>{t('SectionHero.hero2.description')}</p>
                  <SecondaryButton
                    className={css.browseBtn}
                    type="button"
                    aria-label={t('SectionHero.hero2.cta')}
                    onClick={() => useHistoryPush('SearchPage')}
                  >
                    {t('SectionHero.hero2.cta')}
                  </SecondaryButton>
                </div>
              </div>
            </div>

            <div className={css.heroContentWrapper}>
              <div
                className={css.heroContentWrapperInner}
                style={{ backgroundImage: `url(${homeBanner3})`, height: '100%' }}
                aria-label={altFor(3)}
              >
                <div className={css.heroContent}>
                  <Heading as="h1" rootClassName={css.heading}>
                    {t('SectionHero.hero3.title.before')},{' '}
                    <span>{t('SectionHero.hero3.title.emphasis')}</span>
                  </Heading>
                  <p className={css.para}>{t('SectionHero.hero3.description')}</p>
                  <SecondaryButton
                    className={css.browseBtn}
                    type="button"
                    aria-label={t('SectionHero.hero3.cta')}
                    onClick={() => useHistoryPush('NewListingPage')}
                  >
                    {t('SectionHero.hero3.cta')}
                  </SecondaryButton>
                </div>
              </div>
            </div>
          </Slider>
        )}
      </div>
    </div>
  );
}

export default SectionHero;
